export const DOC_TYPES = {
    DRIVING_LICENSE: "DrivingLicense",
    AUDIO_UPLOAD: "AudioUpload",
    UPLOAD: "Upload",
    RESUME: "Resume",
    JOB_PREFERENCE: "JobPreferencesIntent",
    ASSEST: "Asset",
}

// add more for DL,RC etc
export const UPLOAD_DOCUMENT = {
    [DOC_TYPES.DRIVING_LICENSE]: "Upload Driving License",
    [DOC_TYPES.AUDIO_UPLOAD]: "Spoken English",
    [DOC_TYPES.UPLOAD]: "Upload Driving License",
    [DOC_TYPES.RESUME]: "Upload Resume",
    [DOC_TYPES.JOB_PREFERENCE]: "Job Preference",
    [DOC_TYPES.ASSEST]: "Assets/Documents",
}

export const QUESTION_TYPE = {
    UPLOAD: "Upload",
    AUDIO_UPLOAD: "AudioUpload",
    RESUME_UPLOAD: "Resume",
    JOB_PREFERENCE: "JobPreferencesIntent",
    ASSET: "Asset",
}
